module.exports = __webpack_public_path__ + "img/loginbackground.a3dfbce0.png";